import { ApiError } from "./errors/ApiError";
import { isBackendError } from "./errors/isBackendError";
import { NotFoundError } from "./errors/NotFoundError";
import { UnknownApiError } from "./errors/UnknownApiError";

const handleNotOk = async (response: Response) => {
  if (response.status === 404) {
    throw new NotFoundError();
  }

  const body = await response.text();

  let json: unknown;
  try {
    json = JSON.parse(body);
  } catch (e) {
    throw new Error(body || "Network response error");
  }

  if (isBackendError(json)) {
    throw new ApiError(json);
  }

  throw new UnknownApiError();
};

const handleRequest = async <ResponseBody>(
  response: Response
): Promise<ResponseBody> => {
  if (!response.ok) {
    return await handleNotOk(response);
  }
  return response.headers.get("Content-Type")?.includes("json")
    ? response.json()
    : response.text();
};
const handleRequestBlob = async (response: Response): Promise<Blob> => {
  if (!response.ok) {
    return await handleNotOk(response);
  }
  return response.blob();
};

export const getRequest = async <ResponseBody>(
  uri: string,
  backendUrl: string = ""
): Promise<ResponseBody> => {
  return fetch(
    `${backendUrl || process.env.REACT_APP_PUBLIC_BACKEND_URL}${uri}`,
    {}
  ).then((res) => handleRequest(res));
};

export const getRequestBlob = async (
  uri: string,
  backendUrl: string = ""
): Promise<Blob> => {
  return fetch(
    `${backendUrl || process.env.REACT_APP_PUBLIC_BACKEND_URL}${uri}`,
    {}
  ).then((res) => handleRequestBlob(res));
};

export const deleteRequest = async <ResponseBody>(
  uri: string,
  backendUrl: string = "",
  headers = { "Content-Type": "application/json" }
): Promise<ResponseBody> => {
  return fetch(
    `${backendUrl || process.env.REACT_APP_PUBLIC_BACKEND_URL}${uri}`,
    {
      method: "delete",
      headers: { ...headers },
    }
  ).then((res) => handleRequest(res));
};

export const postRequest = async <ResponseBody>(
  uri: string,
  data: any,
  backendUrl: string = "",
  headers = { "Content-Type": "application/json" }
): Promise<ResponseBody> => {
  return fetch(
    `${backendUrl || process.env.REACT_APP_PUBLIC_BACKEND_URL}${uri}`,
    {
      method: "post",
      headers: {
        ...headers,
      },
      body: data,
    }
  ).then((res) => handleRequest(res));
};

export const patchRequest = async <ResponseBody>(
  uri: string,
  data: any,
  backendUrl: string = "",
  headers = { "Content-Type": "application/json" }
): Promise<ResponseBody> => {
  return fetch(
    `${backendUrl || process.env.REACT_APP_PUBLIC_BACKEND_URL}${uri}`,
    {
      method: "patch",
      headers: { ...headers },
      body: data,
    }
  ).then((res) => handleRequest(res));
};

export const putRequest = async <ResponseBody>(
  uri: string,
  data: any,
  backendUrl: string = "",
  headers = { "Content-Type": "application/json" }
): Promise<ResponseBody> => {
  return fetch(
    `${backendUrl || process.env.REACT_APP_PUBLIC_BACKEND_URL}${uri}`,
    {
      method: "put",
      headers: { ...headers },
      body: data,
    }
  ).then((res) => handleRequest(res));
};
